import type { LegalDoc } from "../types";
import { LEGAL_COMPANY as C } from "../company";

export const cauHoiThuongGap: LegalDoc = {
  slug: "cau-hoi-thuong-gap",
  title: "Câu hỏi thường gặp",
  metaTitle: "Câu hỏi thường gặp",
  metaDescription:
    "Câu hỏi thường gặp về gói thuê bao, lượt săn ứng viên, quyền riêng tư và cách ứng tuyển trên Chốt Ca, kèm kênh liên hệ hỗ trợ chính thức.",
  version: "3.0.0",
  effectiveDate: C.effectiveDate,
  intro:
    "Trang này tổng hợp các câu hỏi thường gặp và kênh liên hệ chính thức, chia thành phần dành cho người tìm việc và phần dành cho quán tuyển dụng. Đa số trường hợp được trả lời ngay ở phần dưới, bạn nên xem qua trước khi gửi yêu cầu hỗ trợ.",
  sections: [
    {
      title: "1. Dành cho Người tìm việc",
      sections: [
        {
          title: "Tải ứng dụng ở đâu?",
          body: "Ứng dụng Chốt Ca có trên App Store và Google Play. Vào [trang tải ứng dụng](/app) hoặc [trang dành cho người tìm việc](/viec-lam) để quét mã tải nhanh.",
        },
        {
          title: "Tôi cần làm gì để bắt đầu tìm việc?",
          body: "Tải ứng dụng Chốt Ca, đăng ký bằng **email** hoặc bằng tài khoản Google hoặc Apple, điền hồ sơ rồi bắt đầu xem tin. Bạn **không cần xác minh giấy tờ tuỳ thân** để ứng tuyển. Toàn bộ tính năng dành cho người tìm việc là **miễn phí hoàn toàn**.",
        },
        {
          title: "Dùng có mất phí không?",
          body: `Không, và sẽ không bao giờ. Tạo hồ sơ, xem tin, ứng tuyển, nhận lời mời phỏng vấn đều miễn phí. Chốt Ca **không có gói trả phí nào cho người tìm việc**. Nếu có ai yêu cầu bạn nộp tiền để dùng Chốt Ca hoặc để được nhận việc, đó là lừa đảo — báo ngay tới ${C.abuseEmail}.`,
        },
        {
          title: "Quán thấy số điện thoại của tôi khi nào?",
          body: "Hai trường hợp. **Một**, khi bạn chủ động ứng tuyển một tin, quán đó nhận ngay toàn bộ hồ sơ kèm họ tên, số điện thoại và email của bạn. **Hai**, khi bạn bật chế độ Đang tìm việc và có quán mời phỏng vấn, thông tin của bạn vẫn được che cho tới khi **bạn bấm nhận lời mời và chọn khung giờ**. Từ chối hoặc để hết hạn 24 giờ thì họ không bao giờ thấy số của bạn. Chi tiết tại [Chính sách bảo vệ dữ liệu cá nhân](/privacy) mục 4.",
        },
        {
          title: "Một ngày ứng tuyển được bao nhiêu tin?",
          body: "Tối đa **10 đơn mỗi ngày**, mỗi tin một đơn. Bị quán từ chối thì không nộp lại tin đó được. Tự rút đơn thì nộp lại được khi tin còn mở.",
        },
        {
          title: "Nhận lời mời phỏng vấn rồi đổi ý thì sao?",
          body: "Bạn có **30 phút** kể từ lúc chọn khung giờ để đổi ý mà không bị tính là thất hẹn. Sau 30 phút lịch được chốt, muốn huỷ thì báo sớm cho quán qua số điện thoại đã hiện trong ứng dụng.",
        },
        {
          title: "Làm sao để không bị quán làm phiền nữa?",
          body: "Tắt chế độ **Đang tìm việc** trong hồ sơ để rời khỏi kho ứng viên ngay lập tức. Với một quán cụ thể, dùng chức năng **ẩn quán** để họ không thấy và không mời bạn được. Bạn cũng tắt được thông báo đẩy trong cài đặt ứng dụng hoặc cài đặt thiết bị.",
        },
        {
          title: "Tôi quên mật khẩu, hoặc mất quyền truy cập email đã đăng ký",
          body: `Dùng chức năng **Quên mật khẩu** trong ứng dụng, mã xác thực được gửi về email đã đăng ký. Nếu bạn mất luôn quyền truy cập email đó, gửi yêu cầu tới ${C.email} kèm thông tin đủ để chúng tôi đối chiếu tài khoản, ví dụ họ tên, số điện thoại trong hồ sơ và thời điểm đăng ký gần đúng.`,
        },
        {
          title: "Tôi chưa đủ 18 tuổi thì dùng được không?",
          body: "Từ đủ 15 tuổi bạn tạo được hồ sơ, nhưng pháp luật lao động cấm bạn làm một số công việc và nơi làm việc, gồm pha chế và bán đồ uống có cồn, quán bar, karaoke, vũ trường, và ca đêm từ 22:00 tới 06:00. Dưới 15 tuổi thì chưa tạo hồ sơ được. Chi tiết tại [Quy tắc dành cho Người tìm việc](/worker-conduct) mục 4.",
        },
      ],
    },
    {
      title: "2. Dành cho Nhà tuyển dụng",
      sections: [
        {
          title: "Đăng tin có mất phí không?",
          body: "**Đăng tin miễn phí.** Nhận đơn ứng tuyển, xem hồ sơ đầy đủ của người tự ứng tuyển và mời họ đi phỏng vấn cũng **miễn phí**, kể cả khi bạn đang dùng gói Miễn phí. Phí chỉ phát sinh khi bạn **chủ động mời một người trong kho ứng viên**, việc này trừ 01 lượt săn, và khi bạn **đẩy tin** lên nhóm ưu tiên. Số tin được mở cùng lúc phụ thuộc vào gói. Chi tiết tại [Điều khoản thanh toán](/payment-terms).",
        },
        {
          title: "Vậy Chốt Ca thu tiền ở đâu?",
          body: "Ở **gói thuê bao 30 ngày**. Gói quyết định ba thứ: số tin được mở cùng lúc, số lượt săn ứng viên trong kho người đang tìm việc, và số lượt đẩy tin. Xem chi tiết ở [trang Bảng giá](/bang-gia).",
        },
        {
          title: "Săn ứng viên là gì?",
          body: "Là chủ động mời phỏng vấn một người **chưa nộp đơn** vào tin của bạn, lấy từ kho những người đang bật chế độ tìm việc. Mỗi lời mời như vậy trừ 01 lượt săn và chỉ có ở gói Pro trở lên. Người đó từ chối hoặc không trả lời trong 24 giờ thì lượt được hoàn lại.",
        },
        {
          title: "Khi nào tôi thấy số điện thoại của ứng viên?",
          body: "Người **tự ứng tuyển** vào tin của bạn thì bạn thấy ngay họ tên, số điện thoại và email. Người bạn **săn từ kho ứng viên** thì thông tin bị che cho tới khi chính họ bấm nhận lời mời và chọn khung giờ phỏng vấn.",
        },
        {
          title: "Tôi mời phỏng vấn nhưng ứng viên từ chối, có mất lượt không?",
          body: "**Không.** Lượt săn được hoàn lại tự động khi ứng viên từ chối, khi lời mời hết hạn sau 24 giờ, hoặc khi ứng viên đổi ý trong cửa sổ 30 phút. Bạn chỉ thực sự tiêu một lượt khi lịch phỏng vấn được chốt.",
        },
        {
          title: "Gói thuê bao có tự động gia hạn không?",
          body: "**Không.** Gói có thời hạn 30 ngày và **không tự động gia hạn, không tự động trừ tiền**. Chốt Ca không lưu thẻ nên bạn không cần thao tác huỷ. Hết hạn, tài khoản tự chuyển về gói Miễn phí, tin đang mở vượt hạn mức gói Miễn phí sẽ tạm ẩn khỏi bảng tin và dữ liệu tin, đơn ứng tuyển của bạn vẫn được giữ nguyên.",
        },
        {
          title: "Thanh toán bằng cách nào?",
          body: `Chỉ **chuyển khoản ngân hàng qua mã QR** qua đối tác Sepay. Chốt Ca không nhận thẻ quốc tế, không dùng VNPay, MoMo hay ZaloPay, và không có ví điện tử. Đã chuyển khoản mà sau 30 phút chưa thấy quyền lợi, gửi mã đơn hàng kèm biên lai tới ${C.billingEmail}.`,
        },
        {
          title: "Có hoá đơn giá trị gia tăng không?",
          body: `Có. Sau khi thanh toán, gửi mã số thuế và tên công ty kèm mã đơn hàng tới ${C.billingEmail}.`,
        },
        {
          title: "Chốt Ca có hoàn tiền không?",
          body: `**Không hoàn tiền** khi bạn đổi ý, khi không dùng hết hạn mức, hoặc khi tuyển được người qua kênh khác. Chúng tôi bảo vệ bạn bằng cơ chế hoàn lượt săn nêu ở trên. Trường hợp lỗi thuộc về chúng tôi, ví dụ tính phí trùng hoặc đã trả tiền mà không nhận được quyền lợi, chúng tôi khắc phục hoặc hoàn tiền — gửi yêu cầu tới ${C.billingEmail}.`,
        },
        {
          title: "Tôi có phải xác minh doanh nghiệp mới đăng tin được không?",
          body: "Không bắt buộc. Bạn đăng tin được ngay sau khi tạo tài khoản. Xác minh là tuỳ chọn, gồm mã số thuế và giấy chứng nhận đăng ký kinh doanh, do quản trị viên duyệt thủ công. Doanh nghiệp đã xác minh có nhãn riêng và thường được ứng viên tin tưởng hơn.",
        },
        {
          title: "Chốt Ca có giữ lương hay thu hộ không?",
          body: "**Không.** Chốt Ca chỉ là kênh kết nối. Lương là thoả thuận trực tiếp giữa quán và người lao động, nền tảng không cầm tiền và không trả lương thay.",
        },
        {
          title: "Tôi phải làm gì với hồ sơ của ứng viên không được nhận?",
          body: "**Phải xoá.** Điều 25 Luật Bảo vệ dữ liệu cá nhân 2025 buộc bạn xoá, huỷ thông tin của người dự tuyển khi không tuyển dụng họ, trừ khi có thoả thuận khác với chính người đó. Đây là nghĩa vụ pháp lý của doanh nghiệp bạn. Chi tiết tại [Thoả thuận dành cho Nhà tuyển dụng](/employer-agreement) mục 7.",
        },
      ],
    },
    {
      title: "3. Tài khoản và dữ liệu",
      sections: [
        {
          title: "Tôi muốn xoá tài khoản",
          body: "Người tìm việc: mở ứng dụng, vào **Tài khoản → Cài đặt → Xoá tài khoản**. Chốt Ca **xoá toàn bộ dữ liệu cá nhân** của bạn, không giữ lại để tiếp thị. Email của bạn được giải phóng ngay để đăng ký lại nếu muốn. Chi tiết và thời gian xử lý tại [Hướng dẫn xoá dữ liệu](/data-deletion).",
        },
        {
          title: "Tôi muốn xem hoặc sửa dữ liệu Chốt Ca đang giữ về mình",
          body: `Phần lớn thông tin bạn tự sửa được ngay trong ứng dụng, gồm số điện thoại, ảnh và kinh nghiệm. Để yêu cầu bản sao đầy đủ dữ liệu, hạn chế xử lý hoặc rút lại sự đồng ý, gửi email từ địa chỉ đã đăng ký tới ${C.dpoEmail}. Chúng tôi xác nhận trong 72 giờ và hoàn tất trong tối đa 30 ngày.`,
        },
        {
          title: "Dữ liệu của tôi được lưu ở đâu?",
          body: "Máy chủ và cơ sở dữ liệu của Chốt Ca đặt tại Amazon Web Services khu vực Singapore, hình ảnh lưu trên Cloudflare R2. Chúng tôi công bố đầy đủ danh sách nhà cung cấp và tình trạng chuyển dữ liệu xuyên biên giới tại [Chính sách bảo vệ dữ liệu cá nhân](/privacy) mục 5 và mục 6.",
        },
        {
          title: "Ứng dụng không nhận được thông báo",
          body: `Kiểm tra theo thứ tự: **Cài đặt → Thông báo** trong ứng dụng đã bật chưa, rồi **Cài đặt thiết bị → Chốt Ca → Thông báo**. Trên iOS, chế độ Tập trung hoặc Giấc ngủ có thể chặn thông báo. Vẫn không được, gửi mô tả kèm loại thiết bị tới ${C.email}.`,
        },
      ],
    },
    {
      title: "4. Kênh liên hệ chính thức",
      body: "Chốt Ca **không có tính năng nhắn tin trong ứng dụng**. Mọi liên hệ với chúng tôi đi qua các kênh sau:",
      items: [
        `**Hỗ trợ chung**: ${C.email}`,
        `**Bảo vệ dữ liệu cá nhân**: ${C.dpoEmail}`,
        `**Báo cáo vi phạm và lừa đảo**: ${C.abuseEmail}`,
        `**Thanh toán và hoá đơn**: ${C.billingEmail}`,
        `**Pháp lý và khiếu nại quyết định xử lý**: ${C.legalEmail}`,
        ...(C.hotline ? [`**Hotline**: ${C.hotline}`] : []),
        `**Zalo Official Account**: ${C.zaloOA}`,
      ],
    },
    {
      title: "5. Thời gian phản hồi",
      body: "Giờ hỗ trợ: Thứ Hai tới Thứ Bảy, 9:00 tới 18:00 giờ Việt Nam.",
      items: [
        "Báo cáo nội dung vi phạm: xử lý trong **24 giờ**.",
        "Báo cáo lừa đảo hoặc hành vi gây nguy hiểm: ưu tiên xử lý **ngay trong ngày làm việc**.",
        "Hỗ trợ đăng nhập và tài khoản: **24 giờ làm việc**.",
        "Đối soát giao dịch thanh toán: **03 ngày làm việc**.",
        "Yêu cầu hoàn tiền: **05 ngày làm việc**.",
        "Yêu cầu thực hiện quyền chủ thể dữ liệu: xác nhận trong **72 giờ**, hoàn tất trong **tối đa 30 ngày**.",
        "Khiếu nại quyết định xử lý tài khoản: **07 ngày làm việc**.",
        "Hỗ trợ chung: **24 tới 48 giờ làm việc**.",
      ],
    },
    {
      title: "6. Cảnh báo mạo danh",
      body: `Chốt Ca **không bao giờ**: gọi điện yêu cầu bạn chuyển tiền hay mua thẻ điện thoại, hỏi mật khẩu hoặc mã OTP của bạn, hay gửi tin nhắn SMS. Mọi mã xác thực của chúng tôi **chỉ gửi qua email** từ tên miền chotca.com. Nhận được cuộc gọi hoặc tin nhắn tự xưng là Chốt Ca và yêu cầu những việc trên, hãy dừng lại và báo tới ${C.abuseEmail}.`,
    },
  ],
  contact: {
    title: "7. Liên hệ chung",
    body: [
      C.legalName,
      C.taxId ? `Mã số doanh nghiệp: ${C.taxId}` : null,
      `Địa chỉ: ${C.address}`,
    ]
      .filter(Boolean)
      .join("\n"),
    prefix: "Email: ",
    email: C.email,
  },
};
